export default "__VITE_ASSET__DfL2aPfj__"